var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BlBackdrop",
        {
          attrs: {
            title: "Edit Package Item",
            label: "Update",
            submitLoading: _vm.submitLoading,
            disabled: _vm.isDisabledSubmit
          },
          on: {
            "backdrop-close": function($event) {
              return _vm.$emit("close-modal")
            },
            "backdrop-action": _vm.onSubmit
          }
        },
        [
          _vm.fetchLoading
            ? _c(
                "div",
                {
                  staticClass: "h-100 grid place-items-center",
                  style: { width: "40rem" }
                },
                [_c("div", { staticClass: "blum-loader-sm" })]
              )
            : _c(
                "div",
                {
                  staticClass: "flex flex-col gap-4 overflow-y-auto",
                  style: { width: "40rem", maxHeight: "calc(100vh - 20rem)" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "px-8 flex flex-col gap-4" },
                    [
                      _c("BlInputText", {
                        attrs: { input: _vm.nameInput },
                        on: { changed: _vm.inputHandler }
                      }),
                      _vm._v(" "),
                      _c("BlInputText", {
                        attrs: { input: _vm.descriptionInput },
                        on: { changed: _vm.inputHandler }
                      }),
                      _vm._v(" "),
                      _c("BlInputText", {
                        attrs: { input: _vm.standardRetailPriceInput },
                        on: { changed: _vm.inputHandler }
                      }),
                      _vm._v(" "),
                      _vm.isShowSRPChanged
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "py-2 px-3 flex items-start gap-2 bg-cornflower-200 rounded "
                            },
                            [
                              _c("BlIcon", {
                                staticClass: "h-6 w-6",
                                attrs: { icon: "info", color: "cornflower-8" }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("BlTextBody2", {
                                    staticClass: "text-cornflower-800",
                                    attrs: {
                                      text: "This item is associated with"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass:
                                      "text-cornflower-800 font-bold",
                                    attrs: {
                                      text:
                                        _vm.creditPackageItem.packages.length
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass: "text-cornflower-800",
                                    attrs: {
                                      text:
                                        "package(s). Any changes to its SRP will not influence the SRP of the package(s). To adjust the SRP in the packages, you must edit them manually."
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "w-full h-5 bg-grey-100" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "px-8 flex flex-col gap-4" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-2" },
                        [
                          _c("BlTextSubtitle1", {
                            attrs: { text: "Provider" }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                "Specify which therapists can provide this service. You can choose to make it available for everyone or limit it to selected therapists for more control over credit usage."
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isShowAvailableForEveryoneProvider
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "py-2 px-3 flex items-start gap-2 bg-cornflower-200 rounded "
                            },
                            [
                              _c("BlIcon", {
                                staticClass: "h-6 w-6",
                                attrs: { icon: "info", color: "cornflower-8" }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("BlTextBody2", {
                                    staticClass: "text-cornflower-800",
                                    attrs: {
                                      text:
                                        "The provider for this item cannot be changed to 'Restricted' as it is currently being used in"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass:
                                      "text-cornflower-800 font-bold",
                                    attrs: {
                                      text:
                                        _vm.creditPackageItem
                                          .total_active_appointments
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass: "text-cornflower-800",
                                    attrs: { text: "appointment(s)." }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowRestrictedProvider
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "py-2 px-3 flex items-start gap-2 bg-cornflower-200 rounded "
                            },
                            [
                              _c("BlIcon", {
                                staticClass: "h-6 w-6",
                                attrs: { icon: "info", color: "cornflower-8" }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("BlTextBody2", {
                                    staticClass: "text-cornflower-800",
                                    attrs: {
                                      text:
                                        "The following therapist(s) has active appointments using this item and cannot be removed from the list until all appointments are concluded:"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.creditPackageItem.impacted_therapists,
                                    function(user) {
                                      return _c(
                                        "div",
                                        {
                                          key: user.id,
                                          staticClass:
                                            "px-2 flex items-center gap-2"
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "h-1 w-1 flex-shrink-0 bg-cornflower-800 rounded"
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            staticClass:
                                              "text-cornflower-800 font-bold",
                                            attrs: { text: user.name }
                                          })
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c("BlTextBody2", {
                                        staticClass: "text-cornflower-800",
                                        attrs: {
                                          text: "Total appointments impacted:"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        staticClass:
                                          "text-cornflower-800 font-bold",
                                        attrs: {
                                          text:
                                            _vm.creditPackageItem
                                              .total_active_appointments
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.providerOptions, function(opt) {
                        return _c(
                          "div",
                          {
                            key: opt.value,
                            staticClass: "flex gap-4 cursor-pointer",
                            class: {
                              "pointer-events-none opacity-75": opt.disabled
                            },
                            on: {
                              click: function($event) {
                                _vm.providerInput = opt.value
                              }
                            }
                          },
                          [
                            _c("BlInputRadio", {
                              attrs: {
                                checked: _vm.providerInput === opt.value,
                                disabled: opt.disabled,
                                name: "provider"
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", { attrs: { text: opt.label } })
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm.providerInput === "restricted"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "py-2 px-2 flex flex-col gap-2 bg-slate-200 rounded"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center justify-between"
                                },
                                [
                                  _c("BlTextBody2", {
                                    attrs: {
                                      text:
                                        _vm.usersInput.length +
                                        " therapist(s) selected"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlInputButton", {
                                    attrs: {
                                      type: "outlined",
                                      dense: "",
                                      label: "Add therapist"
                                    },
                                    on: {
                                      clicked: function($event) {
                                        _vm.usersMultiSelectOpened = true
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.usersInput.length
                                ? _c(
                                    "div",
                                    { staticClass: "flex flex-col" },
                                    _vm._l(_vm.usersInput, function(user) {
                                      return _c(
                                        "div",
                                        {
                                          key: user.id,
                                          staticClass:
                                            "py-2 flex items-center justify-between gap-4 border-b border-slate-400"
                                        },
                                        [
                                          !user.name
                                            ? _c("BlTextSubtitle3", {
                                                staticClass: "truncate italic",
                                                attrs: {
                                                  title: "Deleted user",
                                                  text: "Deleted user"
                                                }
                                              })
                                            : _c("BlTextSubtitle3", {
                                                staticClass: "truncate",
                                                attrs: {
                                                  title: user.name,
                                                  text: user.name
                                                }
                                              }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: { text: user.email }
                                          })
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ]
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "absolute left-8 -bottom-14 z-10 flex items-center gap-4"
            },
            [
              _c(
                "BlTooltip",
                {
                  scopedSlots: _vm._u(
                    [
                      _vm.creditPackageItem.in_use
                        ? {
                            key: "tooltip",
                            fn: function() {
                              return [
                                _c("div", { staticClass: "w-48" }, [
                                  _vm._v(
                                    "\n            You can't delete this item because it is currently being used in\n            active appointments and/or package.\n          "
                                  )
                                ])
                              ]
                            },
                            proxy: true
                          }
                        : null
                    ],
                    null,
                    true
                  )
                },
                [
                  _vm._v(" "),
                  _c("BlInputButton", {
                    attrs: {
                      type: "outlined-error",
                      label: "Delete item",
                      disabled: _vm.creditPackageItem.in_use
                    },
                    on: {
                      clicked: function($event) {
                        _vm.deleteOpened = true
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.creditPackageItem.status === "archived"
                ? _c(
                    "BlTooltip",
                    [
                      _c("BlInputButton", {
                        attrs: {
                          type: "outlined",
                          label: "Reactivate item",
                          loading: _vm.submitLoading
                        },
                        on: { clicked: _vm.onReactivate }
                      })
                    ],
                    1
                  )
                : _c(
                    "BlTooltip",
                    [
                      _c("BlInputButton", {
                        attrs: {
                          type: "outlined",
                          label: "Archive item",
                          loading: _vm.submitLoading
                        },
                        on: {
                          clicked: function($event) {
                            _vm.archiveOpened = true
                          }
                        }
                      })
                    ],
                    1
                  )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.usersMultiSelectOpened
        ? _c("UsersMultiSelect", {
            attrs: {
              list: _vm.usersInput,
              disabledList: _vm.creditPackageItem.impacted_therapists
            },
            on: {
              change: function($event) {
                _vm.usersInput = $event
              },
              "close-modal": function($event) {
                _vm.usersMultiSelectOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmProviderChangeOpened
        ? _c("BlBackdrop", {
            attrs: {
              title: "Confirm provider change",
              description:
                "By changing this provider to ''Available for Everyone'', this item will be accessible to all therapists for use in credit transactions. Any active restrictions will be removed, and all therapists will have access to this item. Are you sure you want to proceed?",
              label: "Confirm",
              maxWidth: "40rem",
              submitLoading: _vm.submitLoading,
              disabled: _vm.isDisabledSubmit
            },
            on: {
              "backdrop-close": function($event) {
                _vm.confirmProviderChangeOpened = false
              },
              "backdrop-action": _vm.onSubmit
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c("BlBackdrop", {
            attrs: {
              title: "Delete item",
              description:
                "You are about to delete <b>" +
                _vm.creditPackageItem.name +
                "</b>. Are you sure you want to proceed? This action is irreversible.",
              label: "Delete",
              type: "error",
              submitLoading: _vm.submitLoading
            },
            on: {
              "backdrop-close": function($event) {
                _vm.deleteOpened = false
              },
              "backdrop-action": _vm.onDelete
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.archiveOpened
        ? _c("ArchivePackageItemModal", {
            attrs: { creditPackageItem: _vm.creditPackageItem },
            on: {
              "close-modal": function($event) {
                _vm.archiveOpened = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c923dd24", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c923dd24","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/center/packageItem/EditPackageItemModal.vue
// module id = null
// module chunks = 